<template>
      <div style="width:1300px;margin:0 auto;font-size:13px;">
           <div v-if="showPage" class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:30px;">
                <p class="text-center mb-2">
                     <span style="font-size:15px;">
                       电子商务日志
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
                <div class="mb-1" style="border-bottom:1px solid #3190e8;">
                      <ol class="breadcrumb">
                         <li><a href="#" :class="{active:show==2}" @click.prevent="getAllLog(2)">全部商务日志</a></li>
                         <li><a href="#" :class="{active:show==1}" @click.prevent="getMyLog(1)">我的日志</a></li>
                     </ol>
               </div>
               <div style="text-align:right;" class="mb-1">
                    <button class="btn btn-primary" :class="{active_kan:kanlog==0}" @click="getBlog(1,0)">
                         未审阅的日志
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==1}" @click="getBlog(1,1)">
                         已审阅的日志
                    </button>
                    <!-- <button class="btn btn-info" @click="getBlog(2)">
                          驳回的日志
                    </button> -->
                    <!-- <button class="btn btn-danger" @click="getBlog(3)">
                          已删除的日志
                    </button> -->
                     <button class="btn btn-primary" @click="addLog()">添加日志</button>
               </div>
                 <div v-show="BlogList.length>0">
                    <table class="table table-striped table-hover" ref="print">
                        <thead>
                                <tr style="white-space: nowrap;">
                                     <th class="text-center">标题</th>
                                     <th class="text-center">时间</th>
                                     <!-- <th class="text-center">内容</th> -->
                                     <th class="text-center">作者</th>
                                     <th class="text-center">状态</th>
                                     <th class="text-center">公示</th>
                                     <th class="text-center">回复</th>
                                     <th class="text-center">操作</th>
                               </tr>
                        </thead>
                        <tbody>
                                 <tr v-for="(item,index) in BlogList" :key="index">
                                                            <td class="text-center jz_middle" style="color:green">{{item.title}}</td>
                                                            <td class="text-center jz_middle">{{item.title.substring(0,10)}}</td>
                                                            <!-- <td class="text-center autocut jz_middle">{{}}</td> -->
                                                            <td class="text-center jz_middle" style="color:#f4930a">{{item.truename}}</td>
                                                            <td class="text-center jz_middle" style="color:#36d">{{item.state | getState}}</td>
                                                            <td class="text-center jz_middle" style="color:red">{{item.publicity | gongShi}}</td>
                                                            <td class="text-center jz_middle">{{item.cot}}</td>
                                                            <td v-if="item.username==username" class="text-center jz_middle">
                                                                 <!-- <button class="btn btn-primary">添加</button> -->
                                                                <div>
                                                                   <div v-if="showInformation(item.inserttime)">
                                                                      <button class="btn btn-primary" @click="goLog(item.id)">查看</button>
                                                                      
                                                                      <button v-if="showxiu" class="btn btn-info" @click="change(item.id)">修改</button>
                                                                      
                                                                      <!-- <button class="btn btn-primary" @click="goLog(item.id)">审阅</button> -->
                                                                      <!-- <button class="btn btn-info">驳回</button> -->
                                                                      <button v-if="showxiu" class="btn btn-danger" @click="modificationBlog(item.id)">删除</button>
                                                                      <!-- <button class="btn btn-success">回复</button> -->
                                                                   </div>
                                                                <div v-if="showInformation1(item.inserttime)">
                                                                       <button class="btn btn-primary" @click="goLog(item.id)">查看</button>
                                                                </div>
                                                                </div>
                                                            </td>

                                                            <td v-if="item.username!=username" class="text-center jz_middle">
                                                                 <!-- <button class="btn btn-primary">添加</button> -->
                                                                 <button class="btn btn-primary" @click="goLog(item.id)">查看</button>
                                                                 
                                                                 <!-- <button v-if="shang" class="btn btn-success" @click="change(item.id)">修改</button> -->
                                                                 
                                                                 <!-- <button class="btn btn-primary" @click="goLog(item.id)">审阅</button> -->
                                                                 <!-- <button class="btn btn-info">驳回</button> -->
                                                                 <!-- <button class="btn btn-danger" @click="modificationBlog(item.id)">删除</button> -->
                                                                 <!-- <button class="btn btn-success">回复</button> -->
                                                            </td>
                                                            
                                 </tr>
                        </tbody>
                </table>

                         <div>
                              <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                         </div>
                </div>
                <div v-show="record===0" class="text-center">
                     <img src="../../../static/images/timg.jpg" alt="">
                </div>
                <!-- <p class="text-center">
                        <button class="btn btn-primary" @click="addLog()" >添加日志</button>
                </p> -->
           </div>
      </div>
</template>

<script>
import vPagination from "../../components/Pagination.vue";
export default {
      data(){
          return{
              BlogList:[],
              lxs:5,
              state:'',
              pageIndex:'',
              username:'',
              contents:'',
              id:'',
              title:'',
              reply:'',
              record:'',
              show:2,
              shang:true,
              others:false,
              showxiu:false,
              kanlog:'',
              showPage:false,
          
              
            total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

          }
      },
      components:{
           vPagination,
      },
    filters: {
      getState:function(result) {
            switch(result){
               case 0:
               return "未审阅";
               case 1:
               return "已审阅";
               case 2:
               return "已驳回";
               case 3:
               return "已删除";
            }
        } ,
        gongShi:function(gongShi){
           if(gongShi==1){
                return '已公示'
           }
          //  else{
          //       return '未公示'
          //  }
     },
        changeTitle:function(title){
                  if(title==null){
                       return title
                  }
                  else{
                       return title.substring(22);
                  }
        },
   },
      methods:{
           //展示信息
           showInformation(item){
                if(item.replace(/\-/g, "")<this.getDay1(0)){
                    return false;
                }
                else{
                     return true;
                }
           },
             showInformation1(item){
                if(item.replace(/\-/g, "")<this.getDay1(0)){
                    return true;
                }
                else{
                     return false;
                }
           },
            getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
               return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
               
                return m;
                
            },


              pagechange:function(currentPage){
                 this.changeBlog(currentPage);
     },

           
           //分页日志
           changeBlog(currentPage){
               //  console.log(currentPage);
                const that=this;
                that.state=that.state;
                this.getBlog(currentPage,that.state);

           },
           //查看别人日志时不能修改
           stopChange(){
              this.username = window.sessionStorage.getItem('username');
                
           },
          //获取日志
        getBlog: async function (pageIndex,state) {
             this.state=state;
             if(state===3){this.shang=false}
             else{
                  this.shang=true
                  
             }
          //    if(state===1){
          //         this.showxiu=false;
          //         this.kanlog=1;
          //    }
          //    else{
          //         this.showxiu=true;
               
          //         this.kanlog=0;
          //    }
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkGetBlog',
          obj: JSON.stringify({
               lxs:this.lxs,
               state,
               lx:5,
               pageIndex,
          })
        })
     //    console.log(res)
        if (res.isok) {
             if(res.data.isok){
                  const obj = res.data
                  this.showPage=true
                  this.record = obj.record
                  this.BlogList = obj.rows2
                  this.total = obj.totalCount
                    if(state===1){
                  this.showxiu=false;
                  this.kanlog=1;
                      }
                    else{
                         this.showxiu=true;
                         
                         this.kanlog=0;
                    }

             }
             else{
                  alert(res.data.msg);
             }
        }
        else{
             alert(res.message);
        }
      },
      //我的日志
       getMyLog(lxs){
            this.lxs=lxs;
            this.show=1;
            this.getBlog(1,0);
       },
       getAllLog(lxs){
            this.lxs=lxs;
            this.show=2;
            this.getBlog(1,0);    
       },
       //删除日志
       modificationBlog:async function(id){
          const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkUpBlog',
          obj: JSON.stringify({
               //  username:'kzy001',
                lxs:'4',
                state:'3',
               //  contents:'这是我实验的日志',
                id,
               //  title:'2020-04-27 10:16:24__我的日志',
               //  reply:'',
          })
        })
     //    console.log(res)
        if (res.isok) {
             if(res.data.isok){
               this.$message.success(res.data.msg)
                  this.getBlog(1,this.state)
                  const obj = res.data
             }
        }
       },
       //查看日志
       goLog(id){
            this.$router.push({path: '/BlookLog', query:{id:id}})
       },
       //修改日志
       change(id,title,contents,truename){
            this.$router.push({path: '/changeLog', query:{id:id}})
       },
      //添加日志
       addLog(){
            this.$router.push({path: '/BaddLog'})
       }
      },
     //  beforeRouteEnter(to,from,next){
     //        console.log(to);
     //        console.log(from);
     //         console.log("进入日志列表")
     //         next();
     //  },
     //  beforeRouteLeave(to,from,next){
     //        console.log("离开日志列表")
     //        if(to.name=="lookLog"){
     //           from.meta.keepAlive=true;
     //        }
     //        next();
     //  },
      created(){
          this.getBlog(1,0);
          this.stopChange();
      }
}
</script>

<style lang="less" scoped>
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .breadcrumb > li + li:before {
    color: #CCCCCC;
    content: "/ ";
    padding: 0 5px;
}
.active{
     color:#36d;
}
.active_kan{
     color:red;
}

</style>




// WEBPACK FOOTER //
// src/pages/BusinessLog/BusinessLog.vue